<template>
	<div class="MFAVerify">
		<span @click="cancel" class="back_btn"><i class="el-icon-arrow-left"></i>返回</span>
		<div class="title" style="font-weight: bold">双重验证</div>
		<div class="sub_title">为了您的账户安全，请完成以下验证操作</div>
		<VerifyCore ref="VerifyCore" @submit="loginSecverifyCheck"/>
		<div class="buttons">
			<el-button
				type="primary"
				@click="loginSecverifyCheck"
				style="
					position: absolute;
					left: 35px;
					bottom: 3px;
					width: 450px;
					height: 50px;
					margin-left: 0;
				"
				>提交</el-button
			>
		</div>
	</div>
</template>

<script>
import VerifyCore from "@/components/MFA/VerifyCore";
export default {
	name: "MFAVerify",
	components: {
		VerifyCore,
	},

	methods: {
		init(types, data) {
			this.$refs.VerifyCore.init(types, data);
		},
		loginSecverifyCheck() {
			let codeData = this.$refs.VerifyCore.getCode();
			console.log(codeData);
			if (!codeData) return;
			const { code, type } = codeData;
			if (!code) {
				this.$message.error("请输入验证码");
				return;
			}
			const data = {
				bit: codeData.bit,
				types: [type],
				key: codeData.key,
				code: codeData.code,
			};
			if (type === "sms") {
				data.contactInfo = codeData.phoneNumber;
			} else if (type === "email") {
				data.email = codeData.email;
			} else if (type === "google") {
				// todo
			}
			this.$api.loginSecverifyCheck(data).then((response) => {
				this.$emit("onSuccess", response);
			});
		},
		cancel() {
			this.$emit("onCancel");
		},
	},
};
</script>

<style lang="scss" scoped>
.MFAVerify {
	text-align: left;
}
.back_btn {
	display: inline-block;
	cursor: pointer;
	margin: 20px 0 40px 0;
}
.title {
	font-size: 22px;
	text-align: left;
	margin-bottom: 10px;
}
.sub_title {
	font-size: 12px;
	text-align: left;
	margin-bottom: 10px;
	color: gray;
}
</style>